import styled from 'styled-components';

import { colors } from 'theme';

import { ButtonBase } from './ButtonBase';

export const BorderlessButton = styled(ButtonBase)`
  color: ${colors.battleshipGrey};
  background-color: transparent;
  border-radius: 0;
`;
